import type { TrainingLog } from '~/features/matching/types/matching.type';

/**
 * 홈 해시태그 (시안 B1 §6).
 * @description 시안에 노출된 7개를 순서까지 그대로 옮겼다. 검색 탭의 필터 칩과 동일한 소스를 쓴다.
 */
export const HASHTAGS = [
  '배변문제',
  '짖음문제',
  '분리불안',
  '공격성',
  '고양이',
  '독스포츠',
  '사건사고',
] as const;

/** 수업 신청 폼의 지역 선택지 (시안 B4 — 시/구 2단 select). */
export const REGION_CITIES = ['서울시', '경기도', '인천시', '부산시', '대구시'] as const;

export const REGION_DISTRICTS: Record<string, string[]> = {
  서울시: ['서대문구', '마포구', '은평구', '종로구', '강남구', '송파구', '성동구'],
  경기도: ['성남시', '고양시', '수원시', '용인시', '부천시'],
  인천시: ['연수구', '남동구', '부평구', '서구'],
  부산시: ['해운대구', '수영구', '부산진구', '남구'],
  대구시: ['중구', '수성구', '달서구'],
};

/**
 * 훈련 관리 서랍의 초기 시드 (시안 C3).
 * @description 수락 직후 서랍이 완전히 비어 있으면 이 기능의 의도(훈련 아카이브)가 화면상 드러나지 않아
 *  데모용 1건을 심는다. `requestId` 는 런타임에 채워지므로 여기서는 템플릿만 정의한다.
 */
export const TRAINING_LOG_SEED: Omit<TrainingLog, 'id' | 'requestId'>[] = [
  {
    loggedOn: '2020.01.20',
    memo: '첫 수업 — 배변 패드 위치 진단',
    media: [],
  },
];

/**
 * 지도사의 첫 인사 메시지 (시안 C2 채팅방 상단).
 * @description 수락 → 방 생성 직후 자동 삽입한다. 빈 채팅방을 그대로 보여주면 "수업이 시작되면 생성됩니다"
 *  라는 약속이 무의미해지므로, 방이 생겼다는 사실 자체를 대화로 알린다.
 */
export const TUTOR_GREETING = (tutorName: string, className: string) =>
  `안녕하세요 보호자님? ${className}을 맡은 ${tutorName} 튜터입니다. 🎉 오늘부터 보호자님과 함께 우리 아이의 훈련을 시작할거에요. 😊`;
